import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function SpeakersSection() {
  return <section id="referenten" className="py-24 bg-slate-50 border-y border-slate-200" data-id="element-362">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-363">
        <ScrollReveal variant="up" data-id="element-364">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-365">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-366">
              Lernen Sie von den Besten
            </span>
            <h2 className="text-2xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-367">
              Ihr Referenten-Team
            </h2>
            <p className="text-base sm:text-lg text-slate-500 font-medium leading-relaxed" data-id="element-368">
              Kompetenz und Erfahrung für Ihre zahnärztliche Fortbildung. Unsere
              Akademie setzt auf ein ausgewähltes Team erfahrener Referenten,
              die ihr Wissen verständlich, praxisnah und mit Leidenschaft
              vermitteln.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-369">
          {/* Speaker 1 */}
          <ScrollReveal variant="scale" delay={100} data-id="element-370">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-371">
              <div className="aspect-square overflow-hidden relative" data-id="element-372">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/schwenk.jpg" alt="Dr. Thomas Schwenk" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-373" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-374"></div>
              </div>
              <div className="p-8 relative bg-white flex flex-col flex-grow" data-id="element-375">
                <h3 className="text-2xl font-extrabold text-slate-700 mb-2" data-id="element-376">
                  Dr. Thomas Schwenk
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-377">
                  Prothetik & Parodontologie
                </p>
                <ul className="space-y-3 mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-378">
                  <li className="flex items-start" data-id="element-379">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-380">•</span>
                    Spezialist für Ästhetik & Funktion (DGÄZ)
                  </li>
                  <li className="flex items-start" data-id="element-381">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-382">•</span>
                    Zahnarzttrainer seit 1998
                  </li>
                  <li className="flex items-start" data-id="element-383">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-384">•</span>
                    Mitglied des Lehrkörpers APW
                  </li>
                </ul>
                <Link to="/referenten/dr-thomas-schwenk" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-385">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-386" />
                </Link>
              </div>
            </div>
          </ScrollReveal>

          {/* Speaker 2 */}
          <ScrollReveal variant="scale" delay={200} data-id="element-387">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-388">
              <div className="aspect-square overflow-hidden relative" data-id="element-389">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/striegel.jpg" alt="Dr. Markus Striegel" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-390" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-391"></div>
              </div>
              <div className="p-8 relative bg-white flex flex-col flex-grow" data-id="element-392">
                <h3 className="text-2xl font-extrabold text-slate-700 mb-2" data-id="element-393">
                  Dr. Markus Striegel
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-394">
                  Ästhetische Zahnheilkunde
                </p>
                <ul className="space-y-3 mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-395">
                  <li className="flex items-start" data-id="element-396">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-397">•</span>
                    Spezialist für Ästhetik & Funktion (DGÄZ)
                  </li>
                  <li className="flex items-start" data-id="element-398">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-399">•</span>
                    Zahnarzttrainer seit 1998
                  </li>
                  <li className="flex items-start" data-id="element-400">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-401">•</span>
                    Referent des Curriculums der DGÄZ & APW
                  </li>
                </ul>
                <Link to="/referenten/dr-marcus-striegel" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-402">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-403" />
                </Link>
              </div>
            </div>
          </ScrollReveal>

          {/* Speaker 3 */}
          <ScrollReveal variant="scale" delay={300} data-id="element-404">
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-slate-100 hover:shadow-2xl transition-all duration-500 group flex flex-col h-full" data-id="element-405">
              <div className="aspect-square overflow-hidden relative" data-id="element-406">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/herzog.jpg" alt="Dr. Johanna Herzog" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" data-id="element-407" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-408"></div>
              </div>
              <div className="p-8 relative bg-white flex flex-col flex-grow" data-id="element-409">
                <h3 className="text-2xl font-extrabold text-slate-700 mb-2" data-id="element-410">
                  Dr. Johanna Herzog
                </h3>
                <p className="text-[#3b7780] font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-411">
                  Fokus auf Sportzahnmedizin
                </p>
                <ul className="space-y-3 mb-8 text-sm text-slate-500 font-medium flex-grow" data-id="element-412">
                  <li className="flex items-start" data-id="element-413">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-414">•</span>
                    Vizepräsidentin Dentista e.V.
                  </li>
                  <li className="flex items-start" data-id="element-415">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-416">•</span>
                    Generalsekretärin bei der DGSZM
                  </li>
                  <li className="flex items-start" data-id="element-417">
                    <span className="text-[#59d0d4] mr-3 font-bold" data-id="element-418">•</span>
                    Referentin Curriculum DGSZM & Align
                  </li>
                </ul>
                <Link to="/referenten/dr-johanna-herzog" className="inline-flex items-center text-[#3b7780] font-extrabold hover:text-[#59d0d4] transition-colors group/link mt-auto" data-id="element-419">
                  Mehr Infos{' '}
                  <ArrowRightIcon className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform" data-id="element-420" />
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={400} data-id="element-421">
          <div className="mt-16 text-center" data-id="element-422">
            <p className="text-slate-500 font-bold text-base sm:text-lg" data-id="element-423">
              Gemeinsam stehen sie für höchste Qualität und begleiten Sie auf
              Ihrem individuellen Fortbildungsweg.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}